<template>
<span v-if="value !== 'false'" style="overflow-wrap: anywhere !important;">
    <slot/>
</span>
</template>

<script>
export default {
    props: ['value'],
};
</script>
